"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.entitiesRepository = exports.casesRepository = exports.milestonesRepository = exports.contractsRepository = exports.projectsRepository = exports.lettersRepository = void 0;
const RepositoryReact_1 = __importDefault(require("../../React/RepositoryReact"));
exports.lettersRepository = new RepositoryReact_1.default({
    actionRoutes: {
        getRoute: "contractsLetters",
        addNewRoute: "letterReact",
        editRoute: "letter",
        deleteRoute: "letter",
    },
    name: "contractsLetters",
});
exports.projectsRepository = new RepositoryReact_1.default({
    actionRoutes: {
        getRoute: "projects",
        addNewRoute: "",
        editRoute: "",
        deleteRoute: "",
    },
    name: "projects",
});
exports.contractsRepository = new RepositoryReact_1.default({
    actionRoutes: {
        getRoute: "contracts",
        addNewRoute: "",
        editRoute: "",
        deleteRoute: "",
    },
    name: "contracts",
});
exports.milestonesRepository = new RepositoryReact_1.default({
    actionRoutes: {
        getRoute: "milestones",
        addNewRoute: "",
        editRoute: "",
        deleteRoute: "",
    },
    name: "milestones",
});
exports.casesRepository = new RepositoryReact_1.default({
    actionRoutes: {
        // addNewRoute: "case" pozwala tworzyć Sprawę "w miejscu" z formularza pisma
        // (InlineCreateDrawer). Ta SAMA instancja jest czytana przez CaseSelectMenuElement,
        // dzięki czemu po utworzeniu nowa sprawa trafia do repository.items i odświeża opcje.
        getRoute: "cases",
        addNewRoute: "case",
        editRoute: "case",
        deleteRoute: "",
    },
    name: "cases",
});
exports.entitiesRepository = new RepositoryReact_1.default({
    actionRoutes: {
        getRoute: "entities",
        addNewRoute: "entity",
        editRoute: "entity",
        deleteRoute: "entity",
    },
    name: "entities",
});
